import {useState} from 'react'
import ClsForm from './ClsForm';
import ClsListview from './ClsListview';

const CLS = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <ClsForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <ClsListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}
      </>
  )
}

export default CLS